




import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import ResizeUpdateMixin from '../../common/ts/resizing/ResizeUpdateMixin';

const IconProps = Vue.extend({
  props: {
    icon: {
      type: String,
      default: 'mercedes-benz-star',
    },
    width: {
      type: Number,
      default: 40,
    },
    height: {
      type: Number,
      default: 40,
    },
    mq1: String,
    mq2: String,
    mq3: String,
    mq4: String,
    mq5: String,
    iconTitle: String,
    originalSize: {
      type: Boolean,
      default: false,
    },
  },
});

@Component
export default class Icon extends mixins(IconProps, ResizeUpdateMixin) {
  iconComponent: null | (() => Promise<Icon>) = null;

  parseBreakpoint (bp: string) {
    const sizes: string[] = bp.split(';');
    return {
      width: parseInt(sizes[0], 10),
      height: parseInt(sizes[1], 10),
    };
  }

  @Watch('icon', {
    immediate: true,
  })
  watchIcon () {
    this.iconComponent = () => import(`vue-svg-loader!../../common/icons/${this.icon}.svg`);
  }

  get iconWidth () {
    if (this.originalSize) {
      return '100%';
    }
    let { width } = this;
    if (this.windowWidth < 320) {
      width = this.mq1 ? this.parseBreakpoint(this.mq1).width : this.width;
    }
    if (this.windowWidth >= 320 && this.windowWidth < 480) {
      width = this.mq2 ? this.parseBreakpoint(this.mq2).width : this.width;
    }
    if (this.windowWidth >= 480 && this.windowWidth < 768) {
      width = this.mq3 ? this.parseBreakpoint(this.mq3).width : this.width;
    }
    if (this.windowWidth >= 768 && this.windowWidth < 1024) {
      width = this.mq4 ? this.parseBreakpoint(this.mq4).width : this.width;
    }
    if (this.windowWidth >= 1024 && this.windowWidth < 1280) {
      width = this.mq5 ? this.parseBreakpoint(this.mq5).width : this.width;
    }
    return this.convertPxToRem(width);
  }

  get iconHeight () {
    if (this.originalSize) {
      return '100%';
    }
    let { height } = this;
    if (this.windowWidth < 320) {
      height = this.mq1 ? this.parseBreakpoint(this.mq1).height : this.height;
    }
    if (this.windowWidth >= 320 && this.windowWidth < 480) {
      height = this.mq2 ? this.parseBreakpoint(this.mq2).height : this.height;
    }
    if (this.windowWidth >= 480 && this.windowWidth < 768) {
      height = this.mq3 ? this.parseBreakpoint(this.mq3).height : this.height;
    }
    if (this.windowWidth >= 768 && this.windowWidth < 1024) {
      height = this.mq4 ? this.parseBreakpoint(this.mq4).height : this.height;
    }
    if (this.windowWidth >= 1024 && this.windowWidth < 1280) {
      height = this.mq5 ? this.parseBreakpoint(this.mq5).height : this.height;
    }
    return this.convertPxToRem(height);
  }

  convertPxToRem (pxValue: number) {
    return `${pxValue / 14}rem`;
  }
}
